import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Landing_page.css';
import appointmentService from '../../services/appointment.service';
import assetUrl from '../../utils/assetUrl';

const LandingPage = () => {
    // Î•Î¹ÎºÏŒÎ½ÎµÏ‚ Î³Î¹Î± Ï„Î¿ Carousel
    const heroImages = [
        assetUrl('/img/inhouse_01.jpeg'),
        assetUrl('/img/inhouse_02.jpeg'),
        assetUrl('/img/image-1.jpeg'),
        assetUrl('/img/image-2.jpeg'),
        assetUrl('/img/image-3.jpeg'),
        assetUrl('/img/image-4.jpeg'),
        assetUrl('/img/image-5.jpeg'),
        assetUrl('/img/image-6.jpeg'),
        assetUrl('/img/image-7.jpeg'),
        assetUrl('/img/image-8.jpeg'),
        assetUrl('/img/image-9.jpeg'),
        assetUrl('/img/image-10.jpeg'),
        assetUrl('/img/image-11.jpeg'),
        assetUrl('/img/image-12.jpeg'),
    ];

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const [menServices, setMenServices] = useState<{ id: number; name: string; price: string }[]>([]);
    const [womenServices, setWomenServices] = useState<{ id: number; name: string; price: string }[]>([]);


    useEffect(() => {
        appointmentService.getPackages()
            .then((data: any[]) => {
                const mapped = data.map(pkg => ({
                    id: pkg.id,
                    name: pkg.name ?? pkg.serviceName ?? '',
                    price: `${Number(pkg.price ?? 0)}€`,
                    gender: String(pkg.gender ?? '').toUpperCase()
                })).filter(item => item.name);

                const women = mapped.filter(item => item.gender === 'WOMEN').sort((a, b) => a.id - b.id);
                const men = mapped.filter(item => item.gender === 'MEN').sort((a, b) => a.id - b.id);

                setWomenServices(women);
                setMenServices(men);
            })
            .catch(() => {
                setMenServices([]);
                setWomenServices([]);
            });
    }, []);

    const teamMembers = [
        {
            id: 1,
            name: "Παύλος",
            role: "Master Barber",
            image: assetUrl('/prof_img/men.jpeg'), // Using one of the uploaded images as placeholder
            bio: "Ειδικεύεται σε skin fade, μούσια και καθαρές γραμμές, δουλεύοντας πάντα με προσοχή στη λεπτομέρεια και στο τελείωμα. Από classic και μοντέρνα κουρέματα μέχρι μακριά μαλλιά, φροντίζει κάθε σχήμα να έχει σωστή κίνηση και φυσικό όγκο, προσφέροντας ένα αποτέλεσμα καθαρό, ισορροπημένο και προσεγμένο."
        },
        {
            id: 2,
            name: "Τζούλη",
            role: "Senior Stylist",
            image: assetUrl('/prof_img/women.jpeg'), // Using one of the uploaded images as placeholder
            bio: "Με πολλα χρόνια εμπειρίας στον χώρο της κομμωτικής, εξειδικεύεται στα κουρέματα, τις βαφές, τις τεχνικές balayage και τα χτενίσματα που αναδεικνύουν την προσωπικότητα κάθε γυναίκας. Παρακολουθεί διαρκώς τις νέες τάσεις και εξελίξεις, προσφέροντας σύγχρονες τεχνικές προσαρμοσμένες στις ανάγκες της κάθε πελάτισσας. Δίνει έμφαση στη λεπτομέρεια, στη σωστή διάγνωση της τρίχας και στη διατήρηση της υγείας των μαλλιών, ώστε το αποτέλεσμα να είναι κομψό, ισορροπημένο και υψηλής ποιότητας."
        }
    ];

    // Carousel Effect
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [heroImages.length]);

    return (
        <div className="landing-container">
            {/* Hero Section */}
            <section className="hero" id="home">
                {/* Background Carousel */}
                {heroImages.map((img, index) => (
                    <div 
                        key={index}
                        className={`hero-bg ${index === currentImageIndex ? 'active' : ''}`}
                        style={{ backgroundImage: `url(${img})` }}
                    />
                ))}
                
                <div className="hero-overlay"></div>
                <div className="hero-content">
                    <span className="hero-tagline">EST. 2026 • ATHENS</span>
                    <h1>MYFT HAIR STUDIO</h1>
                    <p className="subtitle">Η απόλυτη εμπειρία περιποίησης για εσάς.</p>
                    <div className="cta-group">
                        <Link to="/men" className="btn-primary">ΑΝΤΡΙΚΟ</Link>
                        <Link to="/women" className="btn-primary">ΓΥΝΑΙΚΕΙΟ</Link>
                        <Link to="/products" className="btn-secondary">Τα προϊόντα μας</Link>
                    </div>
                </div>
            </section>

            {/* About / Philosophy Section */}
            <section className="about-section">
                <div className="about-content">
                    <h2 className="section-title">Η ΦΙΛΟΣΟΦΙΑ ΜΑΣ</h2>
                    <p className="about-text">
                        Στο MYFT HAIR STUDIO, το στυλ δεν αντιγράφεται — δημιουργείται.
Εστιάζουμε στη μοναδικότητα του κάθε ανθρώπου, προσφέροντας υπηρεσίες υψηλής ποιότητας σε ένα μοντέρνο και άνετο περιβάλλον. Δημιουργούμε σύγχρονα, προσεγμένα αποτελέσματα που ανανεώνουν την εικόνα σας με χαρακτήρα και αυτοπεποίθηση.
                    </p>
                    <div className="stats-grid">
                        <div className="stat-item">
                            <span className="stat-number">5+</span>
                            <span className="stat-label">Χρόνια Εμπειρίας</span>
                        </div>
                        <div className="stat-item">
                            <span className="stat-number">200+</span>
                            <span className="stat-label">Ευχαριστημένες Πελάτισσες</span>
                        </div>
                        <div className="stat-item">
                            <span className="stat-number">100%</span>
                            <span className="stat-label">Ποιότητα</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Detailed Services Section */}
            <section className="detailed-services-section">
                <div className="services-wrapper">
                    <h2 className="section-title dark">ΟΙ ΥΠΗΡΕΣΙΕΣ ΜΑΣ</h2>
                    <p className="services-intro">Ανακαλύψτε την πολυτέλεια και την επιστημονική προσέγγιση που προσφέρουμε.</p>

                    <div className="services-container">
                        {/* Men's Column */}
                        <div className="service-column">
                            <h3 className="column-title">ΑΝΤΡΙΚΟ</h3>
                            <ul className="service-list">
                                {menServices.map(service => (
                                    <li key={service.id} className="service-item">
                                        <span className="name">{service.name}</span>
                                        <span className="dots"></span>
                                        <span className="price">{service.price}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Women's Column */}
                        <div className="service-column">
                            <h3 className="column-title">ΓΥΝΑΙΚΕΙΟ</h3>
                            <ul className="service-list">
                                {womenServices.map(service => (
                                    <li key={service.id} className="service-item">
                                        <span className="name">{service.name}</span>
                                        <span className="dots"></span>
                                        <span className="price">{service.price}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    
                </div>
            </section>

             {/* Team Section */}
             <section className="team-section">
                <h2 className="section-title dark">Η ΟΜΑΔΑ ΜΑΣ</h2>
                <div className="team-grid">
                    {teamMembers.map(member => (
                        <div key={member.id} className="team-member">
                            <div 
                                className="member-image" 
                                style={{backgroundImage: `url(${member.image})`, backgroundSize: 'cover', backgroundPosition: 'center'}}
                            ></div>
                            <h3>{member.name}</h3>
                            <p className="role">{member.role}</p>
                            <p className="bio">{member.bio}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* Products Section */}
            <section className="products-section" id="products">
                <h2 className="section-title dark">PREMIUM ΠΡΟΪΟΝΤΑ</h2>
                <div className="products-grid">
                    <div className="product-card">
                        <div className="product-image-placeholder">
                            <img src={assetUrl('/Prod_IMG/don-essential-day-cream.png')} alt="Product 1" />
                        </div>
                        <div className="product-info">
                            <h3>Essential Day Cream & After Shave</h3>
                            <p className="price">€25.00</p>
                        </div>
                    </div>
                    <div className="product-card">
                        <div className="product-image-placeholder">
                            <img src={assetUrl('/Prod_IMG/don_sea_salt_strong.png')} alt="Product 2" />
                        </div>
                        <div className="product-info">
                            <h3>Sea Salt Volumizing Hair Mist Strong</h3>
                            <p className="price">€23.00</p>
                        </div>
                    </div>
                    <div className="product-card">
                        <div className="product-image-placeholder">
                            <img src={assetUrl('/Prod_IMG/curl-creme-definer-200ml.png')} alt="Product 3" />
                        </div>
                        <div className="product-info">
                            <h3>Curl Creme Definer</h3>
                            <p className="price">€22.00</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section className="contact-section" id="contact">
                <div className="contact-header">
                    <span className="contact-subtitle">ΕΙΜΑΣΤΕ ΕΔΩ</span>
                    <h2>Επικοινωνία</h2>
                </div>
                
                <div className="contact-content-wrapper">
                    <div className="map-container">
                         {/* Placeholder Map - Replace src with actual location embed URL */}
                        <iframe 
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3143.744256947268!2d23.8217392!3d38.0064253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14a199beaa443d79%3A0x43b92e25608afa57!2sMYFT%20HAIR%20STUDIO!5e0!3m2!1sel!2sgr!4v1770464351288!5m2!1sel!2sgr" 
                            width="100%" 
                            height="100%" 
                            style={{border:0}} 
                            allowFullScreen={true} 
                            loading="lazy" 
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Salon Location"
                        ></iframe>
                    </div>

                    <div className="contact-info-cards">
                        <div className="info-card">
                            <h3>Τηλεφωνική Επικοινωνία</h3>
                            <div className="contact-row">
                                <span><i className="fas fa-phone-volume"></i> +2106394347</span>
                            </div>
                        </div>
                        <div className="info-card">
                            <h3>Διεύθυνση</h3>
                            <div className="contact-row">
                                <span><i className="fas fa-map-marker-alt"></i> Ειρήνης 81 &, Έαρος 27, Αγ. Παρασκεύη 153 41</span>
                            </div>
                        </div>

                        <div className="info-card">
                            <h3>Social</h3>
                            <div className="social-icons-row">
                                <a href="https://www.instagram.com/myft_hair_studio" className="social-icon-link" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                    <i className="fab fa-instagram"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default LandingPage;
